import type { FetchResponse } from '@cian/http-api';
import { HttpBadStatusCodeError, UnknownError } from '@cian/peperrors/shared';
import {
  fetchAddLegalAgreement,
  TAddLegalAgreementRequest,
  TAddLegalAgreementResponse,
} from '../../repositories/users-features/v1/add-legal-agreement';
import { IApplicationContext } from '../../types/applicationContext';

export const resolveAddLegalAgreement = async (
  context: IApplicationContext,
  parameters: TAddLegalAgreementRequest,
): Promise<void> => {
  const { httpApi, logger } = context;

  try {
    const response = (await fetchAddLegalAgreement({
      httpApi,
      parameters,
    })) as FetchResponse<TAddLegalAgreementResponse>;

    if (response.statusCode === 200) {
      return;
    }

    logger.error(
      new HttpBadStatusCodeError({
        statusCode: response.statusCode,
        message: 'Ошибка при добавлении соглашения',
        domain: 'src/shared/services/addLegalAgreement/service.ts',
      }),
    );

    return;
  } catch (error) {
    logger.error(
      new UnknownError({
        message: 'Ошибка при добавлении соглашения',
        domain: 'src/shared/services/addLegalAgreement/service.ts',
        details: { originalError: error },
      }),
    );

    return;
  }
};

export const resolveAddLegalAgreementBatched = async (
  context: IApplicationContext,
  parametersList: TAddLegalAgreementRequest[],
): Promise<void> => {
  const promises = parametersList.map(parameters => resolveAddLegalAgreement(context, parameters));

  await Promise.all(promises);
};
